/**
 * Garden Gnome / Pano2VR reads container offsetWidth/offsetHeight and listens
 * to window resize. Trigger resize when the fluid wrapper changes size.
 */
const initBoatView360 = () => {
  document
    .querySelectorAll(".boat-page__view-360 [id^='ggpkg_container']")
    .forEach((container) => {
      if (container.dataset.boatView360Init) {
        return;
      }

      container.dataset.boatView360Init = "true";

      const observer = new ResizeObserver(() => {
        window.dispatchEvent(new Event("resize"));
      });

      observer.observe(container);
    });
};

initBoatView360();
